export default "__VITE_ASSET__4QXpoSLw__"